import '@shared/assets/styles/constants.scss';
import '@shared/assets/styles/main.scss';
import { BrowserRouter } from 'react-router';
import { AppRoutes } from './routes/AppRoutes';
import { AppProviders } from './providers/AppProviders';

export const App = () => {

  return (
    <AppProviders>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AppProviders>
  );
};

